import { put, takeEvery } from "redux-saga/effects";
import { fetchMethod } from "../../../services/httpService";
import messagePopup from "../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  SEARCH_COLLEGE_COACH_LIST_START: "SEARCH_COLLEGE_COACH_LIST_START",
  SEARCH_COLLEGE_COACH_SUCCESS: "SEARCH_COLLEGE_COACH_SUCCESS",
  SEARCH_COLLEGE_COACH_FAILED: "SEARCH_COLLEGE_COACH_FAILED",
};

// ============================================ Actions ========================================================
export const getCollegeCoachListStart = (data) => ({
  type: actionType.SEARCH_COLLEGE_COACH_LIST_START,
  payload: data,
});

export const getCollegeCoachSuccess = (data) => ({
  type: actionType.SEARCH_COLLEGE_COACH_SUCCESS,
  payload: data,
});

export const getCollegeCoachFailed = (data) => ({
  type: actionType.SEARCH_COLLEGE_COACH_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function getCollegeCoachReducer(
  state = INIT_STATE,
  action
) {
  switch (action.type) {
    case actionType.SEARCH_COLLEGE_COACH_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.SEARCH_COLLEGE_COACH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.SEARCH_COLLEGE_COACH_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* getCollegeCoachListSaga(action) {
  try {
    const response = yield fetchMethod(`/api/Coachandteamdetails/searchCollegeCoach`, action.payload.data, "post", false);
    let allCoaches = response?.data?.response?.data;
    if (response && response.status === 200) {
        yield put(getCollegeCoachSuccess(allCoaches));
    } else {
      messagePopup("", "Search College Coach List failed", "error");
      yield put(getCollegeCoachFailed("Search College Coach List failed"));
    }
  } catch (error) {
    messagePopup("", "Search College Coach List failed", "error");
    yield put(getCollegeCoachFailed("Search College Coach List failed"));
  }
}

export function* watchCollegeCoachListSaga() {
  yield takeEvery(actionType.SEARCH_COLLEGE_COACH_LIST_START, getCollegeCoachListSaga);
}
